"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditInfo = void 0;
const core_1 = require("@material-ui/core");
const select_1 = require("client/components/material/select");
const text_field_1 = require("client/components/material/text-field");
const React = require("react");
const styles = core_1.createStyles({
    row: {
        "display": "grid",
        "gridTemplateColumns": "150px 150px 115px 200px",
        "gridGap": "1rem",
        "&:not(:last-child)": {
            marginBottom: "1rem"
        }
    },
    trackingField: {
        width: "150px",
        minWidth: "0"
    },
    shippingField: {
        width: "115px",
        minWidth: "0"
    }
});
const decorate = core_1.withStyles(styles);
exports.CreditInfo = decorate((props) => {
    const { classes, creditNumber, note, creditAmount, distributorSelected, onChange, onSelect, shouldDisableCreditAmount } = props;
    return (React.createElement("div", { className: classes.row },
        React.createElement(text_field_1.MaterialTextField, { className: classes.trackingField, onChange: onChange("creditNumber"), label: "Credit #", value: creditNumber }),
        React.createElement(text_field_1.MaterialTextField, { className: classes.trackingField, onChange: onChange("note"), label: "Note", value: note }),
        shouldDisableCreditAmount ? (React.createElement(text_field_1.MaterialTextField, { className: classes.shippingField, label: "Credit Amount", value: creditAmount, disabled: shouldDisableCreditAmount })) : (React.createElement(text_field_1.MaterialTextField, { className: classes.shippingField, onChange: onChange("creditAmount"), type: "number", numType: "price", label: "Credit Amount", value: creditAmount })),
        React.createElement(select_1.MaterialSelect, { onSelect: onSelect, placeholder: "Select a distributor", label: "Distributor", options: props.distributorOptions, value: distributorSelected })));
});



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-review/components/credit-info/credit-info.tsx
// module id = 3583
// module chunks = 0